<script setup>
import { onBeforeUnmount, onMounted, ref, watch } from 'vue';
import * as echarts from 'echarts/core';
import { BarChart, LineChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TooltipComponent,
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
  LineChart,
  BarChart,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  CanvasRenderer,
]);

const props = defineProps({
  /** ECharts option */
  option: {
    type: Object,
    required: true,
  },
  /** 图表高度 */
  height: {
    type: String,
    default: '280px',
  },
});

const rootRef = ref(null);
let chart = null;
let resizeObserver = null;

function render() {
  if (!chart) return;
  chart.setOption(props.option, { notMerge: true });
}

onMounted(() => {
  if (!rootRef.value) return;
  chart = echarts.init(rootRef.value, undefined, { renderer: 'canvas' });
  render();

  resizeObserver = new ResizeObserver(() => {
    chart?.resize();
  });
  resizeObserver.observe(rootRef.value);
});

watch(() => props.option, render, { deep: true });

onBeforeUnmount(() => {
  resizeObserver?.disconnect();
  resizeObserver = null;
  chart?.dispose();
  chart = null;
});
</script>

<template>
  <div
    ref="rootRef"
    class="w-full"
    :style="{ height }"
    role="img"
  />
</template>
